import { HeaderNavbarMobileBaseDefaultBox } from "./header-navbar-mobile-base.default.box";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { HeaderNavbarMobileBaseSiBox } from "./header-navbar-mobile-base.si.box";
import {HeaderNavbarMobileBaseMrGreenBox} from "./header-navbar-mobile-base.mrgreen.box";
import { HeaderNavbarMobileBaseCisBox } from "./header-navbar-mobile-base.cis.box";

export const HeaderNavbarMobileBaseBox = styledByTheme(HeaderNavbarMobileBaseDefaultBox)
    .forSI(HeaderNavbarMobileBaseSiBox)
    .forSICis(HeaderNavbarMobileBaseCisBox)
    .forCis(HeaderNavbarMobileBaseCisBox)
    .forCip(HeaderNavbarMobileBaseCisBox)
    .forMrGreen(HeaderNavbarMobileBaseMrGreenBox)
    .apply();
